import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Wordmark } from "@/components/site/Brand";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Consultations", href: "#consultations" },
  { label: "Gallery", href: "#gallery" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.nav
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,backdrop-filter,box-shadow] duration-500 ${
        scrolled ? "bg-cream/80 backdrop-blur-xl shadow-[0_8px_30px_rgba(47,51,43,0.06)]" : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#top" onClick={(e) => go(e, "#top")} data-testid="nav-logo"><Wordmark /></a>
        <div className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={(e) => go(e, l.href)}
               data-testid={`nav-link-${l.label.toLowerCase()}`}
               className="font-sans text-sm text-olive-sage hover:text-blush-dusty transition-colors duration-300 relative group">
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-blush-dusty group-hover:w-full transition-all duration-300" />
            </a>
          ))}
        </div>
        <a href="#consultations" onClick={(e) => go(e, "#consultations")} data-testid="nav-book-btn"
           className="font-sans text-sm px-6 py-2.5 rounded-full bg-olive-deep text-cream hover:bg-blush-dusty transition-colors duration-300">
          Book a Visit
        </a>
      </div>
    </motion.nav>
  );
}
